/**
 * OOP HTTP Client with unified error handling and credentials support.
 */
export class HttpClient {
  constructor(baseUrl = import.meta.env.VITE_SERVER_URL || '') {
    this.baseUrl = baseUrl;
  }

  async request(path, options = {}) {
    const { headers: extraHeaders, ...rest } = options;
    const url = `${this.baseUrl}${path}`;
    const headers = {
      'Content-Type': 'application/json',
      ...(extraHeaders || {}),
    };

    const res = await fetch(url, {
      credentials: 'include',
      ...rest,
      headers,
    });

    const isJson = res.headers.get('content-type')?.includes('application/json');
    const body = isJson ? await res.json() : null;

    if (!res.ok) {
      const err = new Error(body?.error || `Request failed with status ${res.status}`);
      err.status = res.status;
      err.body = body;
      throw err;
    }

    return body;
  }

  get(path, headers = {}) {
    return this.request(path, { method: 'GET', headers });
  }

  post(path, data, headers = {}) {
    return this.request(path, {
      method: 'POST',
      body: JSON.stringify(data),
      headers,
    });
  }

  put(path, data, headers = {}) {
    return this.request(path, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers,
    });
  }

  delete(path, headers = {}) {
    return this.request(path, { method: 'DELETE', headers });
  }
}

export const http = new HttpClient();
